module.exports = __webpack_public_path__ + "img/组 1.83bcfa2c.webp";